<div class="dialog">
    <div class="dialog-header">签字前请指定『主办部门和签字领导』</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="'100px'">
                    主办部门
                </div>
                <div class="column background-page" [style.width]="'120px'">
                    <select [(ngModel)]="no_4_DepartmentId" (ngModelChange)="onNo3DepartmentChange()">
                        <option *ngFor="let department of departments" [value]="department.value">{{department.label}}
                        </option>
                    </select>
                </div>
                <div class="column background-page" [style.width]="'120px'">
                    <select [(ngModel)]="no_4_UserId">
                        <option [value]="''" [disabled]="true">没有用户</option>
                        <option *ngFor="let user of userTreeNodesMap[no_4_DepartmentId.toString()] ?? []"
                            [value]="user.id">
                            {{user.postName}}/{{user.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'100px'">
                    分管副指挥长
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="no_12_UserId" (ngModelChange)="onNo12UserChange()">
                        <option [value]="''" [disabled]="true">没有用户</option>
                        <option *ngFor="let user of subSu" [value]="user.id">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'100px'">
                    其他副指挥长1
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="no_13_UserId">
                        <option [value]="''">无需其他副指挥长签字</option>
                        <option *ngFor="let user of subSu" [value]="user.id"
                            [disabled]="user.id!.toString() === no_12_UserId.toString() || user.id!.toString() === no_14_UserId.toString()">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'100px'">
                    其他副指挥长2
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="no_14_UserId">
                        <option [value]="''">无需其他副指挥长签字</option>
                        <option *ngFor="let user of subSu" [value]="user.id"
                            [disabled]="user.id!.toString() === no_12_UserId.toString() || user.id!.toString() === no_13_UserId.toString()">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'100px'">
                    指挥长
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="suUserId">
                        <option [value]="''">无需指挥长签字</option>
                        <option *ngFor="let user of su" [value]="user.id">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确定</button>
    </div>
</div>